module.exports = __webpack_public_path__ + "img/down-file-collapse.f50c5960.svg";